export interface InlineEditorState {
    selectionActive: boolean;
}

export const initialState: InlineEditorState = {
    selectionActive: false,
};
